"use client";

import { useEffect } from "react";
import { useSearchParams } from "next/navigation";

export function GclidTracker() {
  const searchParams = useSearchParams();

  useEffect(() => {
    const gclid = searchParams?.get("gclid");
    if (gclid) {
      localStorage.setItem("gclid", gclid);
    }
  }, [searchParams]);

  return null;
}
